import { useSelector } from "react-redux";

export const Statuses = {
  initial: 1,
  pending: 2,
  success: 3,
  failed: 4,
};
export const useKyc = () => {
  const { kyc = {}, isIdentityVerified } = useSelector(
    ({ profileReducer }) => profileReducer,
  );

  const { status, reason } = kyc;

  const isKycPassed = isIdentityVerified;
  const isKycPending = status === Statuses.pending && !isKycPassed;
  const kycFailedMessage = status === Statuses.failed ? reason : undefined;

  return { isKycPassed, isKycPending, kycFailedMessage };
};
